
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members/companies",
      function () {
        return require("private-next-pages/members/companies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members/companies"])
      });
    }
  